
import rzIconWarningTriangle from '../../icons/icon-warning-triangle/index.vue';
import rzTransitionExpand from '../transition-expand/index.vue';
import rzIconCross from '../../icons/icon-cross/index.vue';

export default {
  name: 'rzOffline',
  components: {
    rzTransitionExpand, 
    rzIconWarningTriangle,
    rzIconCross,
  },
  props: {
    title: {
      type: String,
      default: 'Соединение с интернетом временно недоступно',
    },
  },
  data() {
    return {
      isCollapsed: false,
    };
  },
  methods: {
    collapse() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
